// Demo store data model — HALCYON storefront
// Collections = page contexts; Products = sections; Variants = display styles

window.STORE_DATA = (function () {

  const SECTIONS = [
    {
      id: 'hero',
      name: 'Hero',
      tagline: 'image · headline · call to action',
      desc: "The first impression. Set the tone with a bold headline, a supporting line, and a primary call-to-action — over a campaign image, video, or full-bleed brand asset. Built for SS / FW launches and seasonal stories.",
      collections: ['homepage'],
      reviews: 412, rating: 4.9,
      badge: 'Most popular',
      variants: [
        { id: 'split',    name: 'Split layout',  sub: 'text + image' },
        { id: 'centered', name: 'Centered',      sub: 'editorial' },
        { id: 'fullbleed',name: 'Full bleed',    sub: 'image-led' }
      ],
      fields: ['Headline', 'Eyebrow', 'Body copy', 'Primary CTA', 'Secondary CTA', 'Media asset', 'Overlay tint']
    },
    {
      id: 'faq',
      name: 'FAQ',
      tagline: 'questions & answers',
      desc: 'Address objections, reduce support load, and improve SEO with structured questions and answers. Group by topic, mix variants, or keep them flat. Pulled from typed metaobjects so the same Q&A can live on product, collection, and policy pages.',
      collections: ['product'],
      reviews: 287, rating: 4.8,
      badge: null,
      variants: [
        { id: 'accordion', name: 'Accordion',  sub: 'expand / collapse' },
        { id: 'plain',     name: 'Plain text', sub: 'flat list' },
        { id: 'tabbed',    name: 'Tabbed',     sub: 'grouped by topic' }
      ],
      fields: ['Question', 'Answer', 'Topic group', 'Order']
    },
    {
      id: 'related',
      name: 'Related products',
      tagline: 'cross-sell · upsell',
      desc: 'Show complementary or similar products. Curate manually, or auto-populate from collections, tags, and merchandising rules defined in Accentuate fields. Three layouts to match any page rhythm.',
      collections: ['product', 'homepage', 'collection'],
      reviews: 198, rating: 4.7,
      badge: 'New',
      variants: [
        { id: 'grid',     name: '3-column grid', sub: 'classic' },
        { id: 'carousel', name: 'Carousel',      sub: 'horizontal scroll' },
        { id: 'stack',    name: 'Stacked rows',  sub: 'editorial' }
      ],
      fields: ['Title', 'Source collection', 'Rule', 'Limit', 'Sort']
    },
    {
      id: 'pdp-details',
      name: 'Product details',
      tagline: 'descriptive copy blocks',
      desc: "Tell the story behind a product. Long-form copy in headings, body, lists, and pull quotes — all editable through structured fields. Switch between tabbed, accordion, or single-column layouts without touching code.",
      collections: ['product'],
      reviews: 156, rating: 4.7,
      badge: null,
      variants: [
        { id: 'tabs',     name: 'Tabs',          sub: 'overview · story · care' },
        { id: 'accordion',name: 'Accordion',     sub: 'collapsible' },
        { id: 'flow',     name: 'Single column', sub: 'long form' }
      ],
      fields: ['Section heading', 'Body copy', 'Pull quote', 'Image', 'Order']
    },
    {
      id: 'specs',
      name: 'Product specifications',
      tagline: 'structured attributes',
      desc: 'Spec sheets, dimensions, materials, and compliance details — rendered consistently across every product, drawn from typed metafields. Useful for fashion, furniture, electronics, beauty — anywhere structured data matters.',
      collections: ['product'],
      reviews: 124, rating: 4.8,
      badge: null,
      variants: [
        { id: 'table',  name: 'Table',     sub: 'key · value' },
        { id: 'grid',   name: 'Grid',      sub: 'icon cards' },
        { id: 'inline', name: 'Inline list', sub: 'compact' }
      ],
      fields: ['Spec name', 'Value', 'Unit', 'Group', 'Icon']
    },
    {
      id: 'video',
      name: 'Video',
      tagline: 'embedded or hosted',
      desc: 'YouTube, Vimeo, or self-hosted video — with poster image, autoplay rules, and an optional looping background mode. Use it for campaign films, behind-the-scenes, or to bring a static product page to life.',
      collections: ['homepage', 'product'],
      reviews: 92, rating: 4.6,
      badge: null,
      variants: [
        { id: 'inline', name: 'Inline player', sub: 'full width' },
        { id: 'modal',  name: 'Modal launch',  sub: 'lightbox' },
        { id: 'loop',   name: 'Background loop', sub: 'muted · cover' }
      ],
      fields: ['Source URL', 'Poster image', 'Caption', 'Autoplay', 'Loop']
    },
    {
      id: 'banner',
      name: 'Banner',
      tagline: 'announcements · promos',
      desc: 'A flexible promotional banner — text-only, image-backed, or scrolling marquee. Time-bound with start/end dates from custom date fields, and dismissible per visitor.',
      collections: ['homepage', 'collection'],
      reviews: 71, rating: 4.5,
      badge: null,
      variants: [
        { id: 'text',    name: 'Text strip',  sub: 'minimal' },
        { id: 'image',   name: 'Image banner', sub: 'with CTA' },
        { id: 'marquee', name: 'Marquee',     sub: 'scrolling' }
      ],
      fields: ['Headline', 'Subhead', 'CTA', 'Image', 'Start date', 'End date']
    },
    {
      id: 'ingredients',
      name: 'Composition & origin',
      tagline: 'materials · transparency',
      desc: 'Structured composition data — every fabric, every fastening — with traceable origin, certifications, and weight. Each line item is its own metaobject record, so the same fabric story can be reused across every product that uses it.',
      collections: ['product'],
      reviews: 64, rating: 4.9,
      badge: null,
      variants: [
        { id: 'cards',   name: 'Cards',     sub: 'photo + note' },
        { id: 'table',   name: 'Table',     sub: 'name · purpose · origin' },
        { id: 'callout', name: 'Callout',   sub: 'hero material' }
      ],
      fields: ['Name', 'Composition %', 'Origin', 'Purpose', 'Certification', 'Image']
    },
    {
      id: 'image-text',
      name: 'Image or text',
      tagline: 'editorial pairing',
      desc: "Pair imagery with copy in any arrangement. Use it for storytelling, brand pillars, sustainability stories, or seasonal callouts. Three arrangements, and a built-in CTA slot.",
      collections: ['homepage', 'product', 'collection'],
      reviews: 211, rating: 4.7,
      badge: null,
      variants: [
        { id: 'left',  name: 'Image left',  sub: 'text right' },
        { id: 'right', name: 'Image right', sub: 'text left' },
        { id: 'stack', name: 'Stacked',     sub: 'image · text · image' }
      ],
      fields: ['Headline', 'Body copy', 'Image', 'CTA', 'Layout']
    },
    {
      id: 'reviews',
      name: 'Reviews',
      tagline: 'social proof',
      desc: 'Customer reviews surfaced from your review provider — or stored directly as Accentuate fields. Aggregate ratings, photos, verified-buyer badges, and size/fit feedback. Filterable by rating, photo, and verified status.',
      collections: ['product'],
      reviews: 309, rating: 4.8,
      badge: 'Trending',
      variants: [
        { id: 'list',    name: 'List',     sub: 'newest first' },
        { id: 'grid',    name: 'Grid',     sub: 'photo cards' },
        { id: 'summary', name: 'Summary',  sub: 'aggregate' }
      ],
      fields: ['Rating', 'Title', 'Body', 'Author', 'Location', 'Photo', 'Verified', 'Size purchased']
    },
    {
      id: 'size-guide',
      name: 'Size guide',
      tagline: 'sizing reference',
      desc: 'Per-product or per-collection size charts. Render as a measurement table, an illustrated diagram, or an inline panel that sits next to the size selector. cm / inch toggle is automatic.',
      collections: ['product'],
      reviews: 48, rating: 4.6,
      badge: null,
      variants: [
        { id: 'table',      name: 'Table',     sub: 'measurements' },
        { id: 'illustrated',name: 'Illustrated', sub: 'diagram + dimensions' },
        { id: 'inline',     name: 'Inline',    sub: 'next to selector' }
      ],
      fields: ['Size', 'Bust', 'Waist', 'Hip', 'Length', 'Sleeve']
    },
    {
      id: 'swatch',
      name: 'Swatch / color picker',
      tagline: 'visual variant selector',
      desc: "Replace the default variant dropdown with color dots, image tiles, or labelled chips — backed by structured colour metadata, hex codes, and per-variant stock state.",
      collections: ['product'],
      reviews: 132, rating: 4.8,
      badge: null,
      variants: [
        { id: 'dots',  name: 'Color dots',   sub: 'minimal' },
        { id: 'tiles', name: 'Image tiles',  sub: 'product photo' },
        { id: 'chips', name: 'Labelled chips',sub: 'with name' }
      ],
      fields: ['Color name', 'Hex', 'Product image', 'Variant ID', 'Stock state']
    },

    // ─── Features collection — the Accentuate app itself ───
    {
      id: 'metafields',
      name: 'Choose scope',
      tagline: 'products, variants, collections & more',
      desc: "Attach fields to any Shopify scope — products, variants, collections, pages, blogs, articles, orders, customers, and shop. ACF also adds three aggregate scopes not native to Shopify: vendors, locations, and product types.",
      collections: ['features'],
      reviews: 524, rating: 4.9,
      badge: 'Foundation',
      kbUrl: 'https://help.accentuate.io/metafield-definitions/scope',
      variants: [
        { id: 'types',  name: 'Type picker',   sub: '24 field types' },
        { id: 'schema', name: 'Schema view',   sub: 'all definitions' },
        { id: 'rules',  name: 'Validation',    sub: 'per-field rules' }
      ],
      fields: ['Field name', 'Type', 'Namespace', 'Validation', 'Visibility', 'Default value']
    },
    {
      id: 'field-types',
      name: 'Define type',
      tagline: '24 built-in field types',
      kbUrl: 'https://help.accentuate.io/metafield-definitions/fields/field-data-type',
      desc: "Two categories: Shopify-native types (single-line text, boolean, color, JSON, URL, date, integer, decimal, dimensions, references) and ACF types (HTML, markdown, selection, tags, media v2, multi-language text). Each ships with the right input UI and built-in validation.",
      collections: ['features'],
      reviews: 412, rating: 4.9,
      badge: 'Foundation',
      variants: [
        { id: 'picker', name: 'Type picker',  sub: '24 types' },
        { id: 'inputs', name: 'Smart inputs', sub: 'per type' },
        { id: 'rules',  name: 'Validation',   sub: 'per type' }
      ],
      fields: ['Type', 'Sub-type', 'Input', 'Validation', 'Default']
    },
    {
      id: 'editor',
      name: 'Editor',
      tagline: 'edit & manage field values',
      kbUrl: 'https://help.accentuate.io/the-editor/using-the-editor',
      desc: "Enter field values in the Values tab or via Shopify admin's 'More actions → Custom Fields' dropdown. Bulk-edit via Filter & Group → Edit items. Every change is versioned — view history, compare, and restore any previous value with one click.",
      collections: ['features'],
      reviews: 487, rating: 4.9,
      badge: null,
      variants: [
        { id: 'inline', name: 'Inline editor', sub: 'on the product' },
        { id: 'bulk',   name: 'Bulk grid',     sub: 'spreadsheet' },
        { id: 'modal',  name: 'Detail editor', sub: 'rich content' }
      ],
      fields: ['Field key', 'Value', 'Resource', 'Last edited', 'Author']
    },
    {
      id: 'filter-group',
      name: 'Filter & group',
      tagline: 'query products, orders & collections',
      kbUrl: 'https://help.accentuate.io/dashboard/filter-and-group/filter-editor',
      desc: "Build queries with up to 10 selectors using AND/OR operators, brackets, and drag-and-drop reordering across products, variants, collections, and orders. Save filters to preview items, open in ACF bulk editor, or export to CSV.",
      collections: ['features'],
      reviews: 312, rating: 4.8,
      badge: null,
      variants: [
        { id: 'filters', name: 'Filter chips', sub: 'AND / OR' },
        { id: 'groups',  name: 'Group by',     sub: 'collapse rows' },
        { id: 'saved',   name: 'Saved views',  sub: 'team library' }
      ],
      fields: ['Field', 'Operator', 'Value', 'Group by', 'View name']
    },
    {
      id: 'references',
      name: 'Reference Manager',
      tagline: 'bulk-assign metaobject references to products',
      kbUrl: 'https://help.accentuate.io/dashboard/reference-manager',
      desc: "Select products manually or via a saved filter, choose a Metaobject reference field, and apply one or more Metaobject entries in bulk. Operations run in the background via the Activity Log. Up to 128 references per item per Shopify limit.",
      collections: ['features'],
      reviews: 268, rating: 4.8,
      badge: null,
      variants: [
        { id: 'picker', name: 'Reference picker', sub: 'multi-select' },
        { id: 'linked', name: 'Linked panel',     sub: 'on the product' },
        { id: 'graph',  name: 'Inbound refs',     sub: 'who points here' }
      ],
      fields: ['Reference type', 'Target', 'Label', 'Position', 'Required']
    },
    {
      id: 'i18n',
      name: 'Multi-language fields',
      tagline: 'text, markdown & HTML with built-in DeepL translation',
      kbUrl: 'https://help.accentuate.io/metafield-definitions/fields/field-data-type/acf-field-types/multi-language-text',
      desc: "Text, Markdown, and HTML field types store all language content in one Metafield. Configure languages in Settings → Languages, translate with built-in DeepL Pro integration, and access per-locale values in Liquid via {{ product.metafields.accentuate.field[shop.locale] }}.",
      collections: ['features'],
      reviews: 241, rating: 4.7,
      badge: null,
      variants: [
        { id: 'tabs',   name: 'Locale tabs',     sub: 'one at a time' },
        { id: 'side',   name: 'Side by side',    sub: 'compare locales' },
        { id: 'status', name: 'Coverage table',  sub: 'who is behind' }
      ],
      fields: ['Locale', 'Translated value', 'Status', 'Translator', 'Updated']
    },
    {
      id: 'sync',
      name: 'Sync multiple stores',
      tagline: 'sync field definitions across linked stores',
      kbUrl: 'https://help.accentuate.io/metafield-definitions/linking-multiple-stores',
      desc: "Link multiple Shopify stores in Settings and synchronise field definitions — templates, field types, and structure — across them with one click. Keeps your schema consistent across storefronts without manual re-entry.",
      collections: ['features'],
      reviews: 187, rating: 4.8,
      badge: 'Plus',
      variants: [
        { id: 'map',  name: 'Field mapping', sub: 'source → target' },
        { id: 'diff', name: 'Dry-run diff',  sub: 'before commit' },
        { id: 'log',  name: 'Sync log',      sub: 'audit trail' }
      ],
      fields: ['Source store', 'Target store', 'Scope', 'Direction', 'Last run']
    },
    {
      id: 'io',
      name: 'Import & export',
      tagline: 'bulk import & export via CSV',
      kbUrl: 'https://help.accentuate.io/bulk-import-and-export/import-custom-field-values',
      desc: "Import and export custom field values and Metaobjects via CSV. All activity is tracked in the Activity Log with real-time status, error reporting, and the ability to re-download previous exports. Log refreshes every 2 minutes.",
      collections: ['features'],
      reviews: 219, rating: 4.7,
      badge: null,
      variants: [
        { id: 'import',   name: 'Import wizard', sub: 'column mapping' },
        { id: 'export',   name: 'Export config', sub: 'filter & shape' },
        { id: 'schedule', name: 'Scheduled jobs',sub: 'unattended' }
      ],
      fields: ['Format', 'File', 'Columns mapped', 'Schedule', 'Status']
    },
    {
      id: 'versions',
      name: 'Version control',
      tagline: 'every change, reversible',
      desc: "Every change to a field value is versioned. Compare any two versions, restore any earlier value, and see who changed what when. Branch a draft to stage seasonal updates before they go live.",
      collections: ['features'],
      reviews: 173, rating: 4.9,
      badge: null,
      variants: [
        { id: 'history', name: 'History list', sub: 'chronological' },
        { id: 'diff',    name: 'Side by side', sub: 'compare two' },
        { id: 'restore', name: 'Restore',      sub: 'rollback flow' }
      ],
      fields: ['Version', 'Author', 'Changed at', 'Note', 'Status']
    },
    {
      id: 'auto-tag',
      name: 'Automatic tagging',
      tagline: 'rules-based, hands-off',
      desc: "Build rules that automatically tag products based on metafield values, collection membership, price, inventory, or any combination. Rules run on every product save — your tags stay clean as your catalogue grows.",
      collections: ['features'],
      reviews: 154, rating: 4.7,
      badge: null,
      variants: [
        { id: 'rules',   name: 'Rule builder', sub: 'if · then' },
        { id: 'preview', name: 'Affected list',sub: 'before publish' },
        { id: 'runs',    name: 'Run history',  sub: 'what changed' }
      ],
      fields: ['Rule name', 'Condition', 'Tag', 'Scope', 'Last run']
    },
    {
      id: 'long-form',
      name: 'Long-form content',
      tagline: '10× shopify\u2019s character limit',
      desc: "Shopify caps metafield values at 65,535 characters. Accentuate stores up to 10× that — so your full-length editorial copy, ingredient panels, multilingual specs and long-form FAQs all fit in one field. Searchable, indexable, and queryable from the Storefront API.",
      collections: ['features'],
      reviews: 142, rating: 4.9,
      badge: '10× limit',
      variants: [
        { id: 'compare', name: 'Limit compare', sub: 'us vs shopify' },
        { id: 'editor',  name: 'Rich editor',   sub: 'with counter' },
        { id: 'usage',   name: 'Field usage',   sub: 'who needs it' }
      ],
      fields: ['Field', 'Length', 'Limit', 'Format', 'Storage']
    },
    {
      id: 'metaobjects',
      name: 'Metaobjects',
      tagline: 'reusable typed objects',
      desc: "Define structured object types — Author, Material, Recipe, Spec sheet — and reuse them across products, pages and articles. Each instance is queryable, referenceable, and translatable. The same Material record powers every product that uses it.",
      collections: ['features'],
      reviews: 396, rating: 4.9,
      badge: 'New',
      variants: [
        { id: 'define',    name: 'Type definition', sub: 'schema editor' },
        { id: 'instances', name: 'Instance library',sub: 'browse · search' },
        { id: 'usage',     name: 'Where it is used', sub: 'reference graph' }
      ],
      fields: ['Type name', 'Fields', 'Instances', 'References', 'Translatable']
    }
  ];

  const COLLECTIONS = [
    {
      id: 'homepage',
      name: 'Homepage',
      title: 'Homepage sections',
      tagline: 'set the tone',
      desc: "Sections built for the first page visitors land on. Heroes, banners, brand-story blocks, and editorial videos — the pieces that anchor your storefront and convey what you're about in three seconds.",
      hue: 'iris'
    },
    {
      id: 'product',
      name: 'Product page',
      title: 'Product page sections',
      tagline: 'sell with detail',
      desc: 'Everything below the buy box. Detailed copy, specifications, reviews, FAQs, size guides, and trust-building content — the sections that turn a curious visitor into a confident customer.',
      hue: 'blue'
    },
    {
      id: 'collection',
      name: 'Collection page',
      title: 'Collection page sections',
      tagline: 'guide discovery',
      desc: 'Sections that help shoppers navigate categories — promotional banners, editorial intros, and curated recommendations that surface the right pieces at the right moment.',
      hue: 'cyan'
    },
    {
      id: 'features',
      name: 'Features',
      title: 'Features of Accentuate',
      tagline: 'the engine behind every section',
      desc: "The app itself. Every storefront section in this demo is powered by what's in this collection — typed fields, metaobjects, references, translations, versioning. Browse a feature like you'd browse a product: open it, switch variants, see exactly how it works.",
      hue: 'amber'
    }
  ];

  COLLECTIONS.forEach(c => {
    c.products = SECTIONS.filter(s => s.collections.includes(c.id));
  });

  return { SECTIONS, COLLECTIONS, byId: (id) => SECTIONS.find(s => s.id === id), col: (id) => COLLECTIONS.find(c => c.id === id) };
})();
